module.exports = __webpack_public_path__ + "media/Images/icon-check-circle-o-50fe41038c31a8330af653b2855302a6.svg";